
export const generateBarcode = (prefix: string = 'PJ'): string => {
  const timestamp = Date.now().toString();
  const random = Math.random().toString(36).substring(2, 8).toUpperCase();
  return `${prefix}${timestamp.slice(-6)}${random}`;
};

export const validateBarcode = (code: string): boolean => {
  const pattern = /^[A-Z]{2}\d{6}[A-Z0-9]{6}$/;
  return pattern.test(code);
};

export const parseBarcodeInfo = (code: string) => {
  if (!validateBarcode(code)) {
    throw new Error('Invalid barcode format');
  }
  
  return {
    prefix: code.substring(0, 2),
    timestamp: code.substring(2, 8),
    random: code.substring(8),
    isValid: true
  };
};

export const generateQRCode = (data: any): string => {
  // In a real implementation, you would use a QR code library
  // For now, return a placeholder URL
  const encodedData = encodeURIComponent(JSON.stringify(data));
  return `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodedData}`;
};

// Canvas-based barcode generation for printing
export function generateBarcodeCanvas(canvas: HTMLCanvasElement, code: string) {
  const ctx = canvas.getContext('2d');
  if (!ctx) return;

  // Set canvas dimensions
  canvas.width = 300;
  canvas.height = 80;

  // Clear canvas
  ctx.fillStyle = 'white';
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  // Simple barcode representation (vertical lines)
  ctx.fillStyle = 'black';
  const barWidth = 2;
  const spacing = 1;
  let x = 20;

  // Generate pattern based on code
  for (let i = 0; i < code.length; i++) {
    const charCode = code.charCodeAt(i);
    const bars = charCode % 8 + 1; // 1-8 bars per character
    
    for (let j = 0; j < bars; j++) {
      ctx.fillRect(x, 10, barWidth, 40);
      x += barWidth + spacing;
    }
    x += spacing * 2; // Character spacing
  }

  // Add text below barcode
  ctx.fillStyle = 'black';
  ctx.font = '12px monospace';
  ctx.textAlign = 'center';
  ctx.fillText(code, canvas.width / 2, 70);
}

// Print barcode function
export function printBarcode(code: string) {
  const canvas = document.createElement('canvas');
  generateBarcodeCanvas(canvas, code);
  
  const printWindow = window.open('', '_blank');
  if (printWindow) {
    printWindow.document.write(`
      <html>
        <head>
          <title>Barcode - ${code}</title>
          <style>
            body { margin: 0; padding: 20px; text-align: center; }
            canvas { border: 1px solid #ccc; }
          </style>
        </head>
        <body>
          <h3>Prince Jewelry - Item Code: ${code}</h3>
          ${canvas.outerHTML}
          <script>
            window.onload = function() {
              window.print();
              window.close();
            }
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  }
}
